var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );
dependencies["macros/contentful/render-entry.j2"] = require( "macros/contentful/render-entry.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/render-entries.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/macros/contentful/render-entries.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("calculateModuleSpacing")) {
var t_4 = t_1.calculateModuleSpacing;
} else {
cb(new Error("cannot import 'calculateModuleSpacing'")); return;
}
context.setVariable("calculateModuleSpacing", t_4);
output += "\n\n";
var macro_t_5 = runtime.makeMacro(
[], 
["splitModuleEntry", "module", "entryloop", "isSpecialtyShop", "moduleentryloop", "isLazy", "isMobileSlider", "moduleContainsProductGrid", "isFlex", "isGiveaway"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("splitModuleEntry", kwargs.hasOwnProperty("splitModuleEntry") ? kwargs["splitModuleEntry"] : {});
frame.set("module", kwargs.hasOwnProperty("module") ? kwargs["module"] : {});
frame.set("entryloop", kwargs.hasOwnProperty("entryloop") ? kwargs["entryloop"] : {});
frame.set("isSpecialtyShop", kwargs.hasOwnProperty("isSpecialtyShop") ? kwargs["isSpecialtyShop"] : false);
frame.set("moduleentryloop", kwargs.hasOwnProperty("moduleentryloop") ? kwargs["moduleentryloop"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("isLazy", kwargs.hasOwnProperty("isLazy") ? kwargs["isLazy"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isMobileSlider", kwargs.hasOwnProperty("isMobileSlider") ? kwargs["isMobileSlider"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("moduleContainsProductGrid", kwargs.hasOwnProperty("moduleContainsProductGrid") ? kwargs["moduleContainsProductGrid"] : false);
frame.set("isFlex", kwargs.hasOwnProperty("isFlex") ? kwargs["isFlex"] : false);
frame.set("isGiveaway", kwargs.hasOwnProperty("isGiveaway") ? kwargs["isGiveaway"] : false);
var t_6 = "";t_6 += "\n    ";
env.getTemplate("macros/contentful/render-entry.j2", false, "core/templates/macros/contentful/render-entries.j2", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(t_7.hasOwnProperty("renderEntry")) {
var t_10 = t_7.renderEntry;
} else {
cb(new Error("cannot import 'renderEntry'")); return;
}
frame.set("renderEntry", t_10);
t_6 += "\n    ";
var t_11;
t_11 = env.getFilter("lower").call(context, (lineno = 6, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "splitModuleEntry"),"fields.displayType"])));
frame.set("displayType", t_11, true);
if(frame.topLevel) {
context.setVariable("displayType", t_11);
}
if(frame.topLevel) {
context.addExport("displayType", t_11);
}
t_6 += "\n    ";
var t_12;
t_12 = "c-contentful-module__" + "" + runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "splitModuleEntry")),"sys")),"contentType")),"sys")),"id");
frame.set("contentfuContentTypeClass", t_12, true);
if(frame.topLevel) {
context.setVariable("contentfuContentTypeClass", t_12);
}
if(frame.topLevel) {
context.addExport("contentfuContentTypeClass", t_12);
}
t_6 += "\n\n    ";
t_6 += "\n\n    <div class=\"";
t_6 += runtime.suppressValue(env.getFilter("trim").call(context, (lineno = 11, colno = 39, runtime.callWrap(t_4, "calculateModuleSpacing", context, [runtime.contextOrFrameLookup(context, frame, "module"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleentryloop")),"index"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleentryloop")),"length"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleentryloop")),"last"),runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop"),runtime.contextOrFrameLookup(context, frame, "moduleContainsProductGrid"),runtime.contextOrFrameLookup(context, frame, "isFlex"),runtime.contextOrFrameLookup(context, frame, "isGiveaway")]))), env.opts.autoescape);
t_6 += " c-contentful-module ";
t_6 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "contentfuContentTypeClass"), env.opts.autoescape);
t_6 += "\">\n        ";
t_6 += runtime.suppressValue((lineno = 12, colno = 20, runtime.callWrap(t_10, "renderEntry", context, [runtime.contextOrFrameLookup(context, frame, "splitModuleEntry"),runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop"),runtime.makeKeywordArgs({"entryloop": runtime.contextOrFrameLookup(context, frame, "entryloop"),"isLazy": runtime.contextOrFrameLookup(context, frame, "isLazy"),"displayType": runtime.contextOrFrameLookup(context, frame, "displayType"),"isMobileSlider": runtime.contextOrFrameLookup(context, frame, "isMobileSlider")})])), env.opts.autoescape);
t_6 += "\n    </div>";
})});
frame = frame.pop();
return new runtime.SafeString(t_6);
});
context.addExport("renderEntries");
context.setVariable("renderEntries", macro_t_5);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/render-entries.j2"] , dependencies)